/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Custom recording consent text
 */
export type EventTaskConfigRecordingConsentText = string | null;
